import { DsDatePicker, getLocalTimeZone, today } from '@frontends/ds';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BIRTHDAY_MIN, getBirthdayMax, toLocalCalendarDate } from '@/utils/birthday';

const TYPICAL_AGE_YEARS = 30;

const BirthdayPicker = memo(function BirthdayPicker({
  label,
  value,
  onChange,
  isInvalid,
  errorMessage,
}: {
  label: string;
  value?: Date;
  onChange: (value: Date | undefined) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}) {
  const { t } = useTranslation();
  const maxValue = useMemo(getBirthdayMax, []);
  const placeholderValue = useMemo(() => today(getLocalTimeZone()).subtract({ years: TYPICAL_AGE_YEARS }), []);
  const calendarValue = useMemo(() => (value ? toLocalCalendarDate(value) : null), [value]);

  return (
    <DsDatePicker
      isFullWidth
      variant="segments"
      showFooter={false}
      label={label}
      minValue={BIRTHDAY_MIN}
      maxValue={maxValue}
      placeholderValue={placeholderValue}
      value={calendarValue}
      onChange={(date) => onChange(date ? date.toDate(getLocalTimeZone()) : undefined)}
      validationBehavior="aria"
      isInvalid={isInvalid || undefined}
      errorMessage={
        errorMessage ??
        (({ validationDetails }) => t(validationDetails.rangeOverflow ? 'age_restriction' : 'birthdate_invalid'))
      }
    />
  );
});

export default BirthdayPicker;
